var _style, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReleases(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1C75BC;stroke-width:0.7;stroke-miterlimit:2.6131;}\n\t.st1{fill:#1B75BC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.6,2.9L55.6,2.9c1.1,0,2,0.9,2,2v47c0,1.1-0.9,2-2,2l0,0c-1.1,0-2-0.9-2-2v-47C53.6,3.8,54.5,2.9,55.6,2.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,21.9c1.9,1.1,3.1,3.7,3.1,6.6c0,2.8-1.2,5.4-3.1,6.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.6,6c-9.9,8.4-20,12.4-30.3,12.2H12.6l-1.5,2.6v8.4 M53.6,51.2c-9.9-8.4-20-12.4-30.3-12.2H12.6l-1.5-2.6 v-7.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 53.6,
    y1: 6,
    x2: 28.5,
    y2: 39.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.9,
    y1: 19.5,
    x2: 27.6,
    y2: 39.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "26.7,18.1 52.9,29.2 12.6,39  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.6,18.2 9.1,18.2 7.4,19.9 7.4,29.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.6,39 9.1,39 7.4,37.3 7.4,29.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.6,39 26.5,43 28.5,39.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.6,39 12.8,41.9 15.2,44.7 19.4,60.4 21.2,61.1 27.9,61.1 29.5,59.5 26.5,43  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "26.5,43 21.9,61.1 29.1,57.3 15.5,45.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 21.5,
    className: "st0",
    width: 4.1,
    height: 14.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.2,
    y1: 24.2,
    x2: 7.4,
    y2: 34.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.6,
    y1: 18.2,
    x2: 7.4,
    y2: 27.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.4,
    y1: 30.7,
    x2: 12.6,
    y2: 39
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 28.5,
    cy: 39.1,
    r: 1.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.2,
    cy: 57.4,
    r: 1.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 22.2,
    cy: 60.9,
    r: 1.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 53.6,
    cy: 6.5,
    r: 1.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 53.3,
    cy: 29.1,
    r: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 11.7,
    cy: 20.3,
    r: 1.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12.9,
    cy: 38.9,
    r: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 3.4,
    cy: 24.7,
    r: 1.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleases);
export default __webpack_public_path__ + "static/media/Releases.d1aeb2cade33270d0cc3ed3c263adab0.svg";
export { ForwardRef as ReactComponent };